import { useState } from "react";

export default function Logo({ className = "h-12 md:h-16" }) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return (
      <span data-testid="logo-fallback" className="font-serif font-semibold text-navy text-xl leading-none">
        Sempre <span className="text-[#4a7c59]">Accanto</span>
      </span>
    );
  }
  return (
    <img
      data-testid="logo-image"
      src="/logo.png?v=2"
      alt="SEMPRE ACCANTO — La cura nel tempo."
      onError={() => setFailed(true)}
      className={`${className} w-auto object-contain`}
    />
  );
}
